module.exports = __webpack_public_path__ + "public/img/人员布控Bg.d66465e9.png";